import * as XLSX from "xlsx";

export type ExcelColumn<T> = {
  header: string;
  // Връща стойност за дадения ред (низ/число/Date/null)
  value: (row: T) => string | number | boolean | Date | null | undefined;
  width?: number;
};

export type ExportOptions<T> = {
  filename: string; // без разширение
  sheetName?: string;
  columns: ExcelColumn<T>[];
  rows: T[];
  // Редове с текст НАД заглавията (напр. „Количества към …; стойности по
  // текущи цени"), отделени от таблицата с празен ред
  notes?: string[];
};

/**
 * Експортира масив редове като .xlsx файл и го сваля в браузъра.
 */
export function exportToExcel<T>(opts: ExportOptions<T>): void {
  const { filename, sheetName = "Sheet1", columns, rows, notes = [] } = opts;

  const aoa: (string | number | boolean | Date | null)[][] = [];
  if (notes.length) aoa.push(...notes.map((note) => [note]), []);
  aoa.push(columns.map((c) => c.header));

  for (const row of rows) {
    aoa.push(
      columns.map((c) => {
        const v = c.value(row);
        if (v === undefined || v === null) return "";
        return v;
      }),
    );
  }

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  if (columns.some((c) => c.width)) {
    ws["!cols"] = columns.map((c) => ({ wch: c.width ?? 16 }));
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));

  const stamp = formatStamp(new Date());
  XLSX.writeFile(wb, `${filename}_${stamp}.xlsx`);
}

function formatStamp(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}` +
    `_${pad(d.getHours())}${pad(d.getMinutes())}`
  );
}
